export const HIDDEN = 'HIDDEN' as const;
export const VISIBLE = 'VISIBLE' as const;
